import { render, staticRenderFns } from "./probationTips.vue?vue&type=template&id=1fe550a5&scoped=true&"
import script from "./probationTips.vue?vue&type=script&lang=js&"
export * from "./probationTips.vue?vue&type=script&lang=js&"
import style0 from "./probationTips.vue?vue&type=style&index=0&id=1fe550a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe550a5",
  null
  
)

export default component.exports